import { c as _c } from "react/compiler-runtime";
import type { MapData, MapDataLocationFeature } from '@repo/types/maps/map-types';
import { getNearbyPins } from '@repo/types/maps/map-utils';
import { useMemo } from 'react';
export function useNearbyPins(selectedLocation, mapData, t0) {
  const $ = _c(5);
  const proximityLevel = t0 === undefined ? 1 : t0;
  let t1;
  bb0: {
    if (!selectedLocation || !mapData) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== mapData.geojson.features || $[2] !== proximityLevel || $[3] !== selectedLocation) {
      const allFeatures = mapData.geojson.features.filter(_temp);
      t2 = getNearbyPins({
        points: allFeatures,
        referencePoint: selectedLocation,
        proximityLevel
      });
      $[1] = mapData.geojson.features;
      $[2] = proximityLevel;
      $[3] = selectedLocation;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = t2;
  }
  return t1;
}
function _temp(feature) {
  return feature.geometry.type === "Point";
}